export var INFO_BLOCK_TYPE = /*#__PURE__*/function (INFO_BLOCK_TYPE) {
  INFO_BLOCK_TYPE["login"] = "elk";
  INFO_BLOCK_TYPE["move"] = "mnp";
  INFO_BLOCK_TYPE["support"] = "support";
  INFO_BLOCK_TYPE["topUp"] = "balance";
  return INFO_BLOCK_TYPE;
}({});
export var MAIN_WIDGET = 'mainWidget';
export var POSITION_TO_MOVE_BLOCK = 3;
export var BANNER_BLOCK_EVENT = /*#__PURE__*/function (BANNER_BLOCK_EVENT) {
  BANNER_BLOCK_EVENT["click"] = "click";
  BANNER_BLOCK_EVENT["view"] = "view";
  return BANNER_BLOCK_EVENT;
}({});

/** Виды модальных окон в InfoCardsBlock */
export var POPUP_TYPES = /*#__PURE__*/function (POPUP_TYPES) {
  POPUP_TYPES["appDownload"] = "appDownload";
  POPUP_TYPES["supportInfoList"] = "supportInfoList";
  return POPUP_TYPES;
}({});